import type { SimpleKeyboard } from 'react-simple-keyboard';

import { getWritableInputTypesConfig } from '../utils/KeyUtils';
import { KeyboardOptionsExt } from 'components/Keyboard/types';
import { syncShiftTheme } from './shiftLock';

function specialTypes(keyboard: SimpleKeyboard) {
  keyboard.registerModule('specialTypes', () => {
    const { language, type } = keyboard.getOptions() as KeyboardOptionsExt;
    const config = getWritableInputTypesConfig(language)[type];
    if (config?.layout) {
      keyboard.setOptions({
        layoutName: 'default',
        enableLayoutCandidates: false,
        layout: config.layout,
      });
    }

    if (config?.layoutName) {
      keyboard.setOptions({ layoutName: config.layoutName });
      syncShiftTheme(keyboard);
    }
  });
}
export default specialTypes;
